import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql, Link } from "gatsby"
import Layout from "../components/Layout"
import Insight from "../components/NewsInsight/Insight";
import ClientReview from "../components/ClientReview/ClientReview";
import AllAgentReview from "../components/ClientReview/AllAgentReview";
import ReviewsList from "../components/Reviews/ReviewsList";
import { ApiRequest } from "../common/utils/api_request_utils";
import { IsAllAgentReview } from "../common/constant";
import { Container, Row, Col } from "react-bootstrap";
import { breadcrumbs } from "../common/utils/breadcrumbs";
import PaymentTable from "../components/Payment/PaymentTable";
import LeadooScript from "../components/LeadooScript/LeadooScript";
import GuidesResources from "../components/GuidesResources/GuidesResources";
import Journey from "../components/Journey/Journey";
import LocationBlock from "../components/LocationBlock/LocationBlock";
import OurTeam from "../components/OurTeam/OurTeam";
import AreaGuide from "../components/AreaGuide/AreaGuide";
import Customer from "../components/Customer/Customer";
import Careers from "../components/Careers/careers";
import Team from "../components/Team/Team"
import TrustpilotReviews from "../components/TrustpilotReviews/TrustpilotReviews";
import TilesBlock from "../components/TilesBlock/Tiles";

import {RenderComponent} from "gatsby-theme-starberry-lomondgroup/src/modules/render-component";

import _ from "lodash";

const WithoutBannerTemplate = (props) => {

  var GQLPage = props.GQLPage;
  var GQLModules = props.GQLModules;
  const breadcrumbsList = breadcrumbs(GQLPage.menu);
  const wordToNumber = { 'ONE': 1, 'TWO': 2, 'THREE': 3, 'FOUR': 4, 'FIVE': 5 };
  const [reviews, setReviews] = useState([])
  let [averageRating, setAverageRating] = React.useState(0);
  const renderComponent = RenderComponent()

  // useEffect(() => {
  //   ApiRequest({
  //     method: "GET",
  //     url: `${process.env.GATSBY_STRAPI_SRC}/google-reviews/google-review-reviews`
  //   }, (result) => {

  //     setReviews(result)
  //     let sumOfScores = 0;
  //     result.map((review) => {
  //       const reviewStringValue = review.starRating;
  //       sumOfScores += wordToNumber[reviewStringValue];
  //     })
  //     setAverageRating(Math.round(sumOfScores / result.length * 10) / 10);
  //   })

  // }, [])

  //console.log("GQLModules ==>", GQLModules)

  return (
    <div className="search-header news-page">
      <Layout seo_meta={GQLPage.seo_meta} menu_slug={GQLPage?.menu?.slug} popular_search={GQLPage?.menu?.popular_search}>
        <Insight className={'withoutBanner'} title={GQLPage?.title} content={GQLPage?.content} breadcrumbs={breadcrumbsList} GQLModules={GQLModules} />

        {GQLModules?.length > 0 && GQLModules?.map((Module, index) => {
          return (
            <>
              {Module.__typename === "GLSTRAPI_ComponentComponentsReviewSection" && <ReviewsList Module={Module} />}
              {Module.__typename === "GLSTRAPI_ComponentComponentsSelectCollection" && Module.choose_collection === "reviews" && ( <>
                {IsAllAgentReview === true && <AllAgentReview Module={Module} />}

                {reviews?.length > 0 && <ClientReview reviewsList={reviews} averageRating={averageRating} />}
                </>
              )}
              {Module.__typename === "GLSTRAPI_ComponentComponentsSelectCollection" && Module.choose_collection === "guides_and_resources" && ( <GuidesResources Module={Module} />
              )}

              {Module.__typename === "GLSTRAPI_ComponentComponentsSelectCollection" && Module.choose_collection === "offices" && <LocationBlock key={Module} Module={Module} />}

              {Module.__typename === "GLSTRAPI_ComponentComponentsSelectCollection" && Module.choose_collection === "teams" && <OurTeam key={Module} Module={Module} />}

              {Module.__typename === "GLSTRAPI_ComponentComponentsSelectCollection" && Module.choose_collection === "area_guide" && <AreaGuide key={Module} Module={Module} />}

              {Module.__typename === "GLSTRAPI_ComponentComponentsSelectCollection" && Module.choose_collection === "careers" && <Careers key={Module} Module={Module} />}

              {Module.__typename === "GLSTRAPI_ComponentComponentsVideoSection" &&  <Customer key={Module} Module={Module} GQLPage={GQLPage}/>}

              {Module.__typename === "GLSTRAPI_ComponentComponentsShowMeetTeam" && Module.show &&  <Team key={Module} Module={Module} category={Module.team_department} />}

              {Module.__typename === "GLSTRAPI_ComponentComponentsLeadooChatComponent" && <LeadooScript key={Module} Module={Module}/> }

              {Module?.__typename === "GLSTRAPI_ComponentComponentsTilesBoxComponent" && <TilesBlock key={Module} Module={Module} GQLPage={GQLPage} /> }

              {Module.__typename === "GLSTRAPI_ComponentComponentsShowPropertyJourney" && Module.show && <Journey key={Module} />}
              
              {Module.__typename === "GLSTRAPI_ComponentComponentsTrustpilotComponent" && renderComponent === "true" && <TrustpilotReviews key={Module} Module={Module} />}

            </>
          )
        })}

        {(GQLPage?.menu?.slug === "payment-success" || GQLPage?.menu?.slug === "payment-failed") && 
        <Container className='mb-5'>
          <Row>
            <PaymentTable payment_info="" status={GQLPage?.menu?.slug} />
          </Row>
        </Container>
        }
        
      </Layout>
    </div>
  )

}

export default WithoutBannerTemplate